var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "featured-in-article" }, [
    _c("div", { staticClass: "featured-in-article__header" }, [
      _c("h2", { staticClass: "featured-in-article__heading text-center" }, [
        _vm._v(_vm._s(_vm.productsInfo.heading))
      ])
    ]),
    _c(
      "div",
      { staticClass: "featured-in-article__container" },
      _vm._l(_vm.filterProducts(_vm.productsInfo.products), function(
        product,
        index
      ) {
        return _c(
          "div",
          {
            key: "product-" + index,
            staticClass: "featured-in-article__product-card"
          },
          [
            _c(
              "div",
              {
                on: {
                  mouseover: function($event) {
                    _vm.hovered = true
                  },
                  mouseleave: function($event) {
                    _vm.hovered = false
                  }
                }
              },
              [
                _c("product-tile", {
                  attrs: {
                    simple: _vm.isSimpleProductTile,
                    product: product,
                    "enable-simple-tile-cta": _vm.enableSimpleTileCta,
                    "enable-simple-tile": _vm.enableSimpleTile
                  }
                })
              ],
              1
            )
          ]
        )
      }),
      0
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }